// extracted by css-extract-rspack-plugin
export default {"Flash":"PlanSupportBanner-module__Flash__ialpE","Box":"PlanSupportBanner-module__Box__vFjtx","Text":"PlanSupportBanner-module__Text__bZsUu"};